<style lang="scss" scoped>
.product-container {
  .hideFormItem {
    display: none !important;
  }
  .form-container {
    margin-top: 15px;
  }
  .tag-container {
    margin-top: 35px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: nowrap;
    // 左侧
    .left {
      display: flex;
      align-items: center;
      width: 160px;

      .icon {
        display: inline-block;
        width: 5px;
        height: 16px;
        background: #419fff;
      }

      .txt {
        display: inline-block;
        font-weight: 400;
        font-size: 16px;
        color: #303133;
        margin-left: 12px;
      }
    }
  }
  .product-container {
    margin-top: 20px;
    width: 100%;
    min-height: 310px;
    margin-bottom: 50px;

    #qualityStatisticsChart {
      width: 100%;
      height: 310px;
    }
  }
  .product-container2 {
    //margin-top: 20px;
    width: 100%;
    min-height: 310px;
    margin-bottom: 50px;

    #qualityStatisticsChart2 {
      width: 100%;
      height: 310px;
    }
  }
}
</style>
<template>
  <div class="product-container">
    <div class="form-container">
      <el-form :style="{ height: screenWidth > 1232 ? '48px' : '' }" :model="conditions" :inline="true" size="mini">
        <el-form-item :label="$t('xuanzeriqi')">
          <yi_time_input type="datetimerange" :maxTime="365 * 24 * 3600 * 1000" :start.sync="conditions.reportDateStart" :end.sync="conditions.reportDateEnd"> </yi_time_input>
        </el-form-item>
        <el-form-item :label="$t('suoshuzuzhi')">
          <yi_data_select :type="'organization'" :ids.sync="conditions.orgIdSelected" :idsPath.sync="conditions.orgId"></yi_data_select>
        </el-form-item>
        <el-form-item :label="$t('shebeimingcheng')">
          <yi_data_select :multiple="true" :type="'equipment'" :ids.sync="conditions.equipmentId"> </yi_data_select>
        </el-form-item>
        <el-form-item :label="$t('chanpinmingcheng')">
          <yi_data_select :multiple="true" :type="'material2'" :ids.sync="conditions.materialId"> </yi_data_select>
        </el-form-item>
        <el-form-item>
          <el-button @click="getProduct(false)" type="primary" plain="plain">
            {{ $t("sousuo") }}
          </el-button>
          <el-button @click="reset">{{ $t("chongzhi") }} </el-button>
          <yi_curd_expand_button></yi_curd_expand_button>
        </el-form-item>
      </el-form>
    </div>
    <div class="tag-container">
      <div class="left">
        <span class="icon"></span>
        <span class="txt">{{ $t("chanpinbulianglv") }}</span>
      </div>
    </div>
    <div class="product-container" :key="key">
      <div v-loading="searchLoading" id="qualityStatisticsChart"></div>
    </div>

    <div class="tag-container">
      <div class="left">
        <span class="icon"></span>
        <span class="txt">{{ $t("chanpinbuliangyuanyinqushi") }}</span>
      </div>
    </div>
    <div class="product-container2" :key="key">
      <div v-loading="searchLoading" id="qualityStatisticsChart2"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "web_report_equipment_capacity_statistics_quality_statistics_product",
  props: {
    parentParams: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      screenWidth: "", // 可视窗口的宽度
      searchLoading: false,
      key: 0,
      conditions: {},
      qualityCharts: null, //产品不良率
      qualityItemCharts: null, //产品不良原因趋势
      inits: "",
      checkout: "",
    };
  },
  watch: {
    parentParams: {
      handler(n) {
        if (n.orgId) {
          this.$set(this.conditions, "orgIdSelected", n.orgId);
        }
        if (n.firstDate) {
          this.$set(this.conditions, "reportDateStart", new Date(n.firstDate).getTime());
        }
        if (n.lastDate) {
          this.$set(this.conditions, "reportDateEnd", new Date(n.lastDate).getTime());
        }

        setTimeout(() => {
          this.getProduct(true);
          // this.getBadQuantity(true)
        }, 0);
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    this.resize();
    this.utils.event_hub.$on("QUALITY_STATISTICS_RESIZE", () => {
      this.resize();
    });
    this.utils.event_hub.$on("RESIZE", () => {
      this.resize();
    });
  },
  activated() {
    this.resize();
  },
  methods: {
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        this.screenWidth = document.body.clientWidth;
        if (this.qualityCharts != null) {
          this.qualityCharts.resize();
        }
        if (this.qualityItemCharts != null) {
          this.qualityItemCharts.resize();
        }
      }, 500);
    },
    reset() {
      if (this.parentParams.selectedOrgIds !== undefined) {
        this.$set(this.conditions, "materialId", undefined);
        this.$set(this.conditions, "equipmentId", undefined);
        this.$set(this.conditions, "reportDateStart", new Date(this.parentParams.firstDate).getTime());
        this.$set(this.conditions, "reportDateEnd", new Date(this.parentParams.lastDate).getTime());
        this.$set(this.conditions, "orgId", this.parentParams.selectedOrgIds + "");
        this.$set(this.conditions, "orgIdSelected", this.parentParams.orgId);
        this.getProduct();
      }
      if (this.conditions.orgId !== undefined && this.parentParams.selectedOrgIds == undefined) {
        this.conditions.reportDateStart = undefined;
        this.conditions.reportDateEnd = undefined;
        this.conditions.orgId = undefined;
        this.conditions.orgIdSelected = undefined;
        this.conditions.materialId = undefined;
        this.conditions.equipmentId = undefined;
        ++this.key;
      }
    },
    getProduct(init) {
      this.inits = init;

      if (init && !this.conditions.reportDateStart) {
        return false;
      }
      this.searchLoading = true;
      let requestParam = {
        ...this.conditions,
        orderBy: "badQuantityRate desc",
      };
      if (!(requestParam["reportDateStart"] == undefined) && !(requestParam["orgId"] == undefined)) {
        this.getBadQuantity();
      }
      this.checkout = requestParam["reportDateStart"];
      // console.log('gggggggggginit',requestParam['reportDateStart'])
      delete requestParam.orgIdSelected;
      if (Array.isArray(requestParam["equipmentId"]) && requestParam["equipmentId"].length > 0) {
        requestParam["equipmentId"] = requestParam["equipmentId"].join(",");
      }
      if (Array.isArray(requestParam["materialId"]) && requestParam["materialId"].length > 0) {
        requestParam["materialId"] = requestParam["materialId"].join(",");
      }
      if (Array.isArray(requestParam["orgId"]) && requestParam["orgId"].length > 0) {
        requestParam["orgId"] = requestParam["orgId"].join(",");
      }
      return this.http
        .get("/web/report/page/quality_statistics_by_material?" + this.qs.stringify(requestParam))
        .then((response) => {
          this.drawTableChart(response.data.rows);
          this.searchLoading = false;
          // this.drawTableChart2(response.data.rows)
        })
        .catch((error) => {
          this.$message.error(this.$t(error));
          this.searchLoading = false;
        });
      // await this.getBadQuantity()
    },
    getBadQuantity() {
      // if(init && !this.conditions.reportDateStart) {
      //   return false
      // }
      let requestParam = {
        ...this.conditions,
        orderBy: "badQuantityRate desc",
      };
      delete requestParam.orgIdSelected;
      if (Array.isArray(requestParam["equipmentId"]) && requestParam["equipmentId"].length > 0) {
        requestParam["equipmentId"] = requestParam["equipmentId"].join(",");
      }
      if (Array.isArray(requestParam["materialId"]) && requestParam["materialId"].length > 0) {
        requestParam["materialId"] = requestParam["materialId"].join(",");
      }
      if (Array.isArray(requestParam["orgId"]) && requestParam["orgId"].length > 0) {
        requestParam["orgId"] = requestParam["orgId"].join(",");
      }
      return this.http
        .get("/web/report/page/quality_statistics_by_bad_quantity?" + this.qs.stringify(requestParam))
        .then((response) => {
          // this.drawTableChart(response.data.rows)
          this.drawTableChart2(response.data.rows);
        })
        .catch((error) => {
          this.$message.error(this.$t(error));
        });
    },
    drawTableChart(data = []) {
      if (!document.getElementById("qualityStatisticsChart")) {
        return;
      }
      this.qualityCharts = this.echarts.getInstanceByDom(document.getElementById("qualityStatisticsChart"));
      if (this.qualityCharts == null) {
        this.qualityCharts = this.echarts.init(document.getElementById("qualityStatisticsChart"));
      }
      let series = [];
      let xAxis = [];
      let chartData = {};
      if (data.length > 0) {
        xAxis = data.map((item) => {
          return item["materialName"];
        });
        const originData = data.map((item) => {
          return item["badQuantityRate"];
        });
        series.push({
          name: "",
          type: "bar",
          barWidth: "12px",
          label: {
            normal: {
              show: true,
              position: "top",
              formatter: "{c}%",
              color: "#43A0FF",
            },
          },
          itemStyle: {
            normal: {
              color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#419FFF",
                },
                {
                  offset: 1,
                  color: "rgba(227, 227, 227,0.3)",
                },
              ]),
              barBorderRadius: 6,
            },
          },
          data: originData,
          barGap: "80%",
          barCategoryGap: "100%",
        });
      }
      let option = {
        tooltip: {
          trigger: "axis",
          // extraCssText: 'width:200px; white-space:pre-wrap;font-weight:bold',
          formatter: (params) => {
            console.log("paramsparams", params);
            const list = [...params];
            if (list.length === 0) {
              return "";
            } else {
              const name = list[0]["name"];
              const items = [];
              for (let i = 0; i < list.length; i++) {
                items.push(list[i]["marker"] + list[i]["seriesName"] + "&nbsp&nbsp" + list[i]["value"] + "%");
              }
              return name + "<br/>" + items.join("<br />");
            }
          },
        },
        grid: {
          left: "20",
          right: "20",
          bottom: "60",
          top: "16%",
          containLabel: true,
        },
        // legend: {
        //   left: 'center',
        //   top: '5%',
        //   textStyle: {
        //     color: '#000',
        //   },
        //   itemWidth: 12,
        //   itemHeight: 12,
        //   itemGap: 32,
        // },
        dataZoom: [
          {
            show: true,
            height: 18,
            xAxisIndex: [0],
            bottom: 20,
            start: 0,
            end: 100,
            handleIcon: "path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z",
            handleSize: "100%",
            handleStyle: {
              color: "rgba(255, 255, 255,1)",
            },
            textStyle: {
              color: "#909399",
              fontSize: 12,
            },
            fillerColor: "#CBCED4",
            borderColor: "rgba(255, 255, 255,1)",
            backgroundColor: "#F0F2F5",
            showDataShadow: true,
            brushSelect: false,
          },
          {
            type: "inside",
            disabled: false,
          },
        ],
        xAxis: {
          show: true,
          type: "category",
          nameLocation: "end",
          nameTextStyle: {
            fontSize: 14,
          },
          inverse: false,
          splitLine: {
            show: false,
            lineStyle: {
              type: "dashed",
              color: "#000",
              width: 1,
            },
          },
          axisTick: {
            show: true,
            alignWithLabel: false,
            interval: "auto",
            inside: false,
            length: 5,
            lineStyle: {
              type: "solid",
              width: 1,
              color: "#909399",
            },
          },
          axisLine: {
            show: true,
            lineStyle: {
              type: "solid",
              width: 1,
              color: "#909399",
            },
          },
          axisLabel: {
            interval: 0, // 间隔长度，可自定义（如果是时间格式，echarts会自动处理）
            rotate: 0, // 横坐标上label的倾斜度
            showMaxLabel: true, // 显示最大刻度
            showMinLabel: true, // 显示最小刻度
            hideOverlap: true, //隐藏互相遮挡的文本标签
            color: "#909399",
          },
          data: xAxis,
        },
        yAxis: {
          type: "value",
          data: [0, 20, 40, 60, 80, 100],
          axisLabel: {
            show: true,
            interval: "auto",
            formatter: "{value}",
          },
          nameTextStyle: {
            color: "#909399",
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: "solid",
              color: "#e4e7ed",
            },
          },
        },
        series: series,
      };
      this.qualityCharts.setOption(option);
    },
    drawTableChart2(data = []) {
      this.qualityItemCharts = this.echarts.getInstanceByDom(document.getElementById("qualityStatisticsChart2"));
      if (this.qualityItemCharts == null) {
        this.qualityItemCharts = this.echarts.init(document.getElementById("qualityStatisticsChart2"));
      }
      let series = [];
      let xAxis = [];
      let chartData = {};
      if (data.length > 0) {
        xAxis = data.map((item) => {
          return item["desc"];
        });
        const originData = data.map((item) => {
          return item["badQuantityRate"];
        });
        series.push({
          name: "",
          type: "bar",
          barWidth: "12px",
          label: {
            normal: {
              show: true,
              position: "top",
              formatter: "{c}%",
              color: "#5F45FF",
            },
          },
          itemStyle: {
            normal: {
              color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#5C41FF",
                },
                {
                  offset: 1,
                  color: "rgba(227, 227, 227,0.3)",
                },
              ]),
              barBorderRadius: 6,
            },
          },
          data: originData,
          barGap: "80%",
          barCategoryGap: "100%",
        });
      }
      let option = {
        tooltip: {
          trigger: "axis",
          // extraCssText: 'width:150px; white-space:pre-wrap;font-weight:bold',
          formatter: (params) => {
            console.log("paramsparams", params);
            const list = [...params];
            if (list.length === 0) {
              return "";
            } else {
              const name = list[0]["name"];
              const items = [];
              for (let i = 0; i < list.length; i++) {
                items.push(list[i]["marker"] + list[i]["seriesName"] + "&nbsp&nbsp" + list[i]["value"] + "%");
              }
              return name + "<br/>" + items.join("<br />");
            }
          },
        },
        grid: {
          left: "20",
          right: "20",
          bottom: "60",
          top: "16%",
          containLabel: true,
        },
        // legend: {
        //   left: 'center',
        //   top: '5%',
        //   textStyle: {
        //     color: '#000',
        //   },
        //   itemWidth: 12,
        //   itemHeight: 12,
        //   itemGap: 32,
        // },
        dataZoom: [
          {
            show: true,
            height: 18,
            xAxisIndex: [0],
            bottom: 20,
            start: 0,
            end: 100,
            handleIcon: "path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z",
            handleSize: "100%",
            handleStyle: {
              color: "rgba(255, 255, 255,1)",
            },
            textStyle: {
              color: "#909399",
              fontSize: 12,
            },
            fillerColor: "#CBCED4",
            borderColor: "rgba(255, 255, 255,1)",
            backgroundColor: "#F0F2F5",
            showDataShadow: true,
            brushSelect: false,
          },
          {
            type: "inside",
            disabled: false,
          },
        ],
        xAxis: {
          show: true,
          type: "category",
          nameLocation: "end",
          nameTextStyle: {
            fontSize: 14,
          },
          inverse: false,
          splitLine: {
            show: false,
            lineStyle: {
              type: "dashed",
              color: "#000",
              width: 1,
            },
          },
          axisTick: {
            show: true,
            alignWithLabel: false,
            interval: "auto",
            inside: false,
            length: 5,
            lineStyle: {
              type: "solid",
              width: 1,
              color: "#909399",
            },
          },
          axisLine: {
            show: true,
            lineStyle: {
              type: "solid",
              width: 1,
              color: "#909399",
            },
          },
          axisLabel: {
            // margin: 8,
            // interval: 'auto',
            // rotate: 0,
            // fontSize: 14,
            // color: '#909399',
            interval: 0, // 间隔长度，可自定义（如果是时间格式，echarts会自动处理）
            rotate: 0, // 横坐标上label的倾斜度
            showMaxLabel: true, // 显示最大刻度
            showMinLabel: true, // 显示最小刻度
            hideOverlap: true, //隐藏互相遮挡的文本标签
            color: "#909399",
          },
          data: xAxis,
        },
        yAxis: {
          type: "value",
          data: [0, 20, 40, 60, 80, 100],
          axisLabel: {
            show: true,
            interval: "auto",
            formatter: "{value}",
          },
          nameTextStyle: {
            color: "#909399",
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: "solid",
              color: "#e4e7ed",
            },
          },
        },
        series: series,
      };
      this.qualityItemCharts.setOption(option);
    },
  },
};
</script>

<style scoped></style>
